<template>
  <myDialog
    :isDialog="isDialog"
    title="稽查处理"
    :width="'800px'"
    @handleClose="handleClose"
  >
    <template #content>
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="120px">
        <!-- 认定选项区域 -->
        <div class="recognition-options">
          <div
            v-for="opt in recognitionOptions"
            :key="opt.value"
            class="option-item"
            :class="{ active: formData.recognitionType === opt.value }"
            @click="formData.recognitionType = opt.value"
          >
            <el-checkbox
              :value="formData.recognitionType === opt.value"
              @click.native.prevent
            />
            <span class="option-text">{{ opt.label }}</span>
          </div>
        </div>

        <!-- 认定无效时显示：是否撤回原认定结论 -->
        <el-form-item v-if="formData.recognitionType === 'invalid'" label="">
          <el-checkbox v-model="formData.isRevokeOriginal">
            是否撤回原认定结论
          </el-checkbox>
        </el-form-item>

        <!-- 稽核意见 -->
        <el-form-item label="稽核意见" prop="auditOpinion" required>
          <el-input
            v-model="formData.auditOpinion"
            type="textarea"
            placeholder="请输入稽核意见"
            :rows="4"
            resize="vertical"
          />
        </el-form-item>

        <!-- 稽核办结日期 -->
        <el-form-item label="稽核办结日期" prop="auditCompleteDate" required>
          <el-date-picker
            v-model="formData.auditCompleteDate"
            type="date"
            placeholder="请选择稽核办结日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>

        <!-- 稽核人 -->
        <el-form-item label="稽核人" prop="auditor" required>
          <el-input
            v-model="formData.auditor"
            placeholder="请输入稽核人"
          />
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <el-button @click="handleClose">取消</el-button>
      <el-button type="success" @click="handleSave" :loading="submitLoading">保存稽核</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">提交稽核</el-button>
    </template>
  </myDialog>
</template>

<script>
export default {
  name: 'AuditHandle',
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      submitLoading: false,
      recognitionOptions: [
        { label: '认定有效', value: 'valid' },
        { label: '认定无效', value: 'invalid' },
        { label: '需要复审', value: 'review' }
      ],
      formData: {
        recognitionType: 'valid', // 默认认定有效
        isRevokeOriginal: false,  // 是否撤回原认定结论（仅认定无效时显示）
        auditOpinion: '',
        auditCompleteDate: '',
        auditor: ''
      },
      rules: {
        auditOpinion: [
          { required: true, message: '请输入稽核意见', trigger: 'blur' }
        ],
        auditCompleteDate: [
          { required: true, message: '请选择稽核办结日期', trigger: 'change' }
        ],
        auditor: [
          { required: true, message: '请输入稽核人', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    isDialog(val) {
      if (val) {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.formData = {
        recognitionType: 'valid',
        isRevokeOriginal: false,
        auditOpinion: '',
        auditCompleteDate: '',
        auditor: ''
      }
      this.$refs.formRef?.resetFields()
    },
    handleClose() {
      this.$emit('handleClose')
    },
    handleSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          this.$emit('save', { ...this.formData, action: 'save' })
          this.submitLoading = false
        }
      })
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          this.$emit('submit', { ...this.formData, action: 'submit' })
          this.submitLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.recognition-options {
  display: flex;
  gap: 16px;
  padding: 16px;
  border: 1px dashed #b3d8ff;
  border-radius: 4px;
  background: #fafafa;
  margin-bottom: 20px;

  .option-item {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #f7f7f7;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;

    &.active {
      background: #eaf2fe;

      :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
        background-color: #297dee;
        border-color: #297dee;
      }

      :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
        color: #297dee;
      }
    }

    .option-text {
      font-size: 14px;
      color: #303133;
    }
  }
}

:deep(.el-form-item) {
  margin-bottom: 18px;
}

:deep(.el-form-item__label) {
  font-weight: 400;
}

:deep(.el-dialog__header) {
  background: #297dee !important;
  padding: 17px 20px;
}

:deep(.el-dialog__title) {
  color: #fff !important;
  font-weight: 700;
  font-size: 17px;
}

:deep(.el-dialog__headerbtn) {
  top: 17px;
  width: 24px;
  height: 24px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;

  .el-dialog__close {
    color: #fff;
  }
}

:deep(.el-dialog__footer) {
  padding: 10px 20px;
  background: #f3f6f7;
  display: flex;
  justify-content: flex-end;
}

:deep(.el-button) {
  padding: 8px 24px;
  border-radius: 4px;
}
</style>
